module.exports = __webpack_public_path__ + "static/media/Optus.697ac28b.jpg";